// src/stores/currencies.ts
import { defineStore } from 'pinia';
import axios from 'axios';
import { computed, ref } from 'vue';
import type { Currency, CurrenciesResponse } from '@/types/currencies';
import { sortCurrencies, getCurrencySymbol } from '@/helpers/currencyHelper';
import { useETagCachedAPI } from '@/utils/cache/etagCache';
import { defaultCurrency } from '@/utils/variables';
export const useCurrenciesStore = defineStore('currencies', () => {
    // State
    const currencies = ref<Currency[]>([]);
    const loadingFlag = ref(false);
    const currency = computed(() => {
        return currencies.value[0].code || defaultCurrency;
    });
    // Функция получения данных
    const fetchCurrencies = async () => {
        const response = await axios.get<CurrenciesResponse>('/main-api/informational/all_currencies');
        const sorted = sortCurrencies(response.data.currencies);
        const result = sorted.map((code) => ({
            code,
            symbol: getCurrencySymbol(code)
        }));

        return result;
    };

    // Create an ETag-cached API client
    const cachedAPI = useETagCachedAPI<Currency[]>(fetchCurrencies);

    // Load currencies with ETag caching
    const awaitGetCurrencies = async () => {
        loadingFlag.value = true;
        try {
            const result = await cachedAPI.fetch();
            currencies.value = result;
            return result;
        } catch (error) {
            console.error('[CurrenciesStore] Failed to load currencies:', error);
            throw error;
        } finally {
            loadingFlag.value = false;
        }
    };

    return {
        currencies,
        currency,
        loadingFlag,
        awaitGetCurrencies
    };
});
